import { DocumentsContainer } from "./DocumentsContainer";
import { CloseOutline, WarningSquare } from "@carbon/icons-react";
import { Button } from "../../../../atom/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../utils/consts/routes";

export const NoDocumentsUploaded = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <DocumentsContainer icon={WarningSquare} title={t("Upload your documents")}>
      <div className="flex flex-col justify-center items-center gap-[24px]">
        <CloseOutline size={24} className="text-gray-376" />
        <p className="text-[16px] leading-[20.16px] text-black">
          {t("You haven't added any documents yet")}
        </p>
        <Button
          onClick={() => navigate(ROUTES.documents)}
          label={t("Start uploading!")}
          type="tertiary"
        />
      </div>
    </DocumentsContainer>
  );
};
